"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _theme = require("@vds/theme");
var _templateObject;
var propTypes = exports.propTypes = {
  /**
   * @ignore
   */
  active: _propTypes["default"].bool,
  /**
   * @ignore
   */
  color: _propTypes["default"].string,
  /**
   * @ignore
   */
  colorConfig: _propTypes["default"].object
};
var defaultProps = exports.defaultProps = {
  active: false,
  color: "#FFFFFF",
  colorConfig: _theme.colors
};
var normalizeColor = function normalizeColor(color) {
  var sanitizedColor = color.toLowerCase();
  switch (sanitizedColor) {
    case "jet black":
      return "#4A4A4A";
    case "silver":
      return "#DEDEDE";
    case "gold":
      return "#D6C6A9";
    case "rose gold":
      return "#F6D6BE";
    case "black":
      return "#000000";
    default:
      return sanitizedColor;
  }
};

/**
 * @ignore
 */
var ColorSwatch = /*#__PURE__*/_styledComponents["default"].div.attrs({
  tabIndex: -1,
  className: "radioSwatch"
}).withConfig({
  displayName: "ColorSwatch",
  componentId: "sc-fd18hy-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: inline-block;\n  height: ", ";\n  margin: ", ";\n  max-width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  outline: none;\n  position: relative;\n  width: ", ";\n\n  ", ";\n"])), function (_ref) {
  var color = _ref.color;
  return normalizeColor(color);
}, function (_ref2) {
  var size = _ref2.size;
  return (0, _javascriptStyleHelpers.calculateRem)(size);
}, function (_ref3) {
  var swatchMargin = _ref3.swatchMargin;
  return swatchMargin;
}, (0, _javascriptStyleHelpers.calculateRem)(56), function (_ref4) {
  var size = _ref4.size;
  return (0, _javascriptStyleHelpers.calculateRem)(size);
}, function (_ref5) {
  var size = _ref5.size;
  return (0, _javascriptStyleHelpers.calculateRem)(size);
}, function (_ref6) {
  var size = _ref6.size;
  return (0, _javascriptStyleHelpers.calculateRem)(size);
}, function (_ref7) {
  var active = _ref7.active,
    selected = _ref7.selected,
    disabled = _ref7.disabled,
    colorConfig = _ref7.colorConfig;
  return !active && !selected && !disabled && "\n    border: 1px solid ".concat(colorConfig.coolGray6, ";\n    \n  ");
});
ColorSwatch.propTypes = propTypes;
ColorSwatch.defaultProps = defaultProps;
var _default = exports["default"] = ColorSwatch;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/inputs/dist/cjs/components/RadioSwatch/ColorSwatch.js
// module id = 1457
// module chunks = 0